var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('label',{staticStyle:{"margin-top":"15px","font-weight":"bold","margin-left":"30px"}},[_vm._v("电子地图")]),_c('brick-map-chart',{ref:"mapChart",staticStyle:{"height":"100%","margin-top":"-7%"},attrs:{"data":_vm.data},on:{"spaceChoose":_vm.spaceClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }